import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { withErrorBoundary } from '../../../hocs/withErrorBoundary';
import {
  selectUiPopupVisible,
  selectUiPopupContentType,
  selectUiPopupContentOptions,
} from '../../../redux/ui/selectors';
import { actions as popupActions } from '../../../redux/ui/popup';
import { actions as reqSendReportActions } from '../../../redux/complaints/reqSendReport';

const mapStateToProps = state => ({
  visible: selectUiPopupVisible(state),
  contentOptions: selectUiPopupContentOptions(state),
  contentType: selectUiPopupContentType(state),
});

const mapDispatchToProps = {
  hidePopup: popupActions.hide,
  sendReport: reqSendReportActions.send,
};

export const enhance = compose(
  withErrorBoundary,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ intl: { formatMessage } }) => ({
    formatMessage,
  })),
);



// WEBPACK FOOTER //
// ./src/components/common/AppPopup/enhance.js